import React from 'react';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import ArrowCircleUpIcon from '@mui/icons-material/ArrowCircleUp';
import { useTranslationContext } from 'contexts/TranslationContext/TranslationContext';
import { LinkItem } from 'components/LinkItem/LinkItem';
import { useSupportMailtoLink } from 'features/settings/hooks/useInternalUserMetaData';

export const SupportAndFeedbackMobileContent = () => {
  const { translation } = useTranslationContext();
  const mailtoLink = useSupportMailtoLink();

  return (
    <>
      <LinkItem
        textColor="primary"
        leftIcon={<HelpOutlineIcon color="secondary" />}
        href="https://support.wellframe.com/"
        className="support-and-feedback__help-center-item"
        marginY={2}
      >
        {translation('help_center')}
      </LinkItem>
      <LinkItem
        leftIcon={<ArrowCircleUpIcon color="secondary" />}
        href={mailtoLink}
        className="support-and-feedback__help-center-item"
        showLinkIcon={false}
        textColor="primary"
        marginY={2}
      >
        {translation('submit_feedback')}
      </LinkItem>
    </>
  );
};
